import {
  HTTP_SELCOMPANY_FETCHING,
  HTTP_SELCOMPANY_SUCCESS,
  HTTP_SELCOMPANY_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_SELCOMPANY_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_SELCOMPANY_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_SELCOMPANY_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
